import { useEffect, useState } from "react";
import { Phone, MessageCircle, ArrowUp } from "lucide-react";
import { useSite } from "@/site/SiteContext";

const FloatingButtons = () => {
  const { contact } = useSite();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-20 right-4 sm:bottom-20 sm:right-6 z-40 flex flex-col gap-3 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <button
        data-testid="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Back to top"
        className="flex items-center justify-center w-12 h-12 rounded-full bg-card border border-gold/30 text-gold hover:bg-gold hover:text-black transition-colors self-center"
      >
        <ArrowUp size={20} />
      </button>
      <a
        data-testid="float-whatsapp"
        href={`https://wa.me/${contact.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <MessageCircle size={26} className="relative" />
      </a>
      <a
        data-testid="float-phone"
        href={`tel:${contact.phoneTel}`}
        aria-label="Phone"
        className="flex items-center justify-center w-14 h-14 rounded-full bg-gold text-black shadow-lg hover:scale-110 transition-transform"
      >
        <Phone size={24} />
      </a>
    </div>
  );
};

export default FloatingButtons;
